// extracted by mini-css-extract-plugin
export default {"container":"loader_container__cklGI","wrapper":"loader_wrapper__tzB0C","loader":"loader_loader__qJHEg","balls":"loader_balls__i+3Ul","progress":"loader_progress__sMAsq"};